import { type EntityTagResponse } from "common";
import { type JSX } from "react";
import { Tooltip } from "react-tooltip";

interface TagsCellProps {
  tags: EntityTagResponse[];
  rowId: string | number;
  variant?: "table" | "card";
}

export default function TagsCell({
  tags,
  rowId,
  variant = "table",
}: TagsCellProps): JSX.Element | null {
  if (tags.length === 0) return null;
  const visible = tags.slice(0, 2);
  const remaining = tags.length - visible.length;
  const tooltipId = `tags-cell-${rowId}`;
  const pill =
    variant === "card"
      ? "inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium text-white"
      : "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium text-white";
  const overflow =
    variant === "card"
      ? "inline-flex items-center rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600"
      : "inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600";
  return (
    <>
      <div
        className="flex flex-wrap gap-1 cursor-pointer"
        data-tooltip-id={tooltipId}>
        {visible.map(tag => (
          <span
            key={tag.id}
            className={pill}
            style={{ backgroundColor: tag.color ?? "#6B7280" }}>
            {tag.name}
          </span>
        ))}
        {remaining > 0 && <span className={overflow}>+{remaining}</span>}
      </div>
      {tags.length > 2 && (
        <Tooltip
          id={tooltipId}
          place="bottom"
          className="z-10"
          content={tags.map(tag => tag.name).join("\n")}
          style={{ whiteSpace: "pre-line" }}
        />
      )}
    </>
  );
}
